<template>
  <span ref="cell">{{ formatDate(date) }}</span>
</template>

<script>
import moment from 'moment';
import eventBus from '../../../js/event-bus';

export default {
  name: 'AlertCell',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    date() {
      return this.data.data.dateArrived;
    },
    cell() {
      return this.$refs.cell;
    },
  },
  mounted() {
    eventBus.$on(`dateArrived-${this.data.rowIndex}`, (row) => {
      this.handleDeliveryDate(row);
    });
  },
  methods: {
    updateDate(e) {
      if (moment(e, 'DD/MM/YYYY', true).isValid()) return moment(e, 'DD/MM/YYYY').toDate();
      if (moment(e, 'DD-MM-YYYY', true).isValid()) return moment(e, 'DD-MM-YYYY').toDate();
      return null;
    },
    formatDate(date) {
      if (date) return moment(date).format('DD/MM/YYYY');
      return '—';
    },
    handleDeliveryDate(data) {
      const estimatedDelivery = moment(data.value);
      const deliveredDate = moment(this.updateDate(data.data.dateArrived));
      let diff;
      const currentDate = moment(new Date());

      if (data.data.state === 37) {
        if (currentDate.isValid() && deliveredDate.isValid() && typeof this.cell !== 'undefined') {
          diff = currentDate.diff(deliveredDate, 'days');
          if (diff > 0) {
            this.cell.title = this.$t('shipping.deliverDate.late', { count: Math.abs(diff), date: deliveredDate.format('DD/MM/YYYY') });
            this.cell.style.color = '#BE0027'; // #BE0027
          } else if (diff === 0) {
            this.cell.style.color = '#000000'; // #ECECEC
          }
        } else if (!deliveredDate.isValid() && typeof this.cell !== 'undefined') {
          this.cell.style.color = '#000000'; // #ECECEC
        }
      } else if (data.data.state === 39 && data.data.dateDeactivate !== null) {
        const dateDeactivation = moment(this.updateDate(data.data.dateDeactivate));

        if (dateDeactivation.isValid() && deliveredDate.isValid()) {
          diff = dateDeactivation.diff(deliveredDate, 'days');

          if (diff > 0) {
            this.cell.title = this.$t('shipping.deliverDate.late', { count: Math.abs(diff), date: deliveredDate.format('DD/MM/YYYY') });
            this.cell.style.color = '#BE0027'; // #BE0027
          } else if (diff === 0) {
            this.cell.style.color = '#000000'; // #ECECEC
          }
        } else if (!deliveredDate.isValid() && typeof this.cell !== 'undefined') {
          this.cell.style.color = '#000000'; // #ECECEC
        }
      }
    },
  },
};
</script>
